
import { CLOSE_NAVIGATION_BAR_OVERFLOW_MENU, OPEN_NAVIGATION_BAR_OVERFLOW_MENU } from '../base/dialog';
import { ReducerRegistry, set } from '../base/redux';

import {
    ACTION_TOGGLE_WHITE_BOARD,
    CLEAR_TOOLBOX_TIMEOUT,
    CLOSE_CARMODE_MODAL,
    FLOAT_TOOLBOX_HIDDEN,
    FULL_SCREEN_CHANGED,
    HANGUP_MENU,
    OPEN_CARMODE_MODAL,
    OPEN_WHITE_BOARD,
    SET_FULL_SCREEN,
    SET_LABELS_VISIBLE,
    SET_OVERFLOW_DRAWER,
    SET_OVERFLOW_MENU_VISIBLE,
    SET_SHARE_MENU_VISIBLE,
    SET_TOOLBAR_HOVERED,
    SET_TOOLBOX_ALWAYS_VISIBLE,
    SET_TOOLBOX_ENABLED,
    SET_TOOLBOX_TIMEOUT,
    SET_TOOLBOX_TIMEOUT_MS,
    SET_TOOLBOX_VISIBLE,
    SET_WHITEBOARD_INSTANCE,
    TOGGLE_OVERFLOW_MENU,
    TOGGLE_REACTIONS_BUTTON,
    TOGGLE_TOOLBOX_VISIBLE,
    TOGGLE_TOOLBOX_ZOOMIN,
    TOGGLE_TOOLBOX_ZOOMOUT
} from './actionTypes';

declare var interfaceConfig: Object;

/**
 * Returns initial state for toolbox's part of Redux store.
 *
 * @private
 * @returns {{
 *     alwaysVisible: boolean,
 *     enabled: boolean,
 *     hovered: boolean,
 *     overflowDrawer: boolean,
 *     overflowMenuVisible: boolean,
 *     timeoutID: number,
 *     timeoutMS: number,
 *     zoomin: number,
 *     zoomout: number,
 *     visible: boolean,
 *     labelsVisible: boolean,
 *     showReactions: boolean,
 *     isNavigationBarOverflowMenuOpen: boolean,
 *     isShareMenu: any
 * }}
 */
function _getInitialState() {
    // Does the toolbar eventually fade out, or is it always visible?
    let alwaysVisible = false;

    // let isNavigationBarOverflowMenuOpen = false;

    // Toolbar (initial) visibility.
    let visible = false;

    // Default toolbox timeout for mobile app.
    let timeoutMS = 5000;

    if (typeof interfaceConfig !== 'undefined') {
        if (interfaceConfig.INITIAL_TOOLBAR_TIMEOUT) {
            timeoutMS = interfaceConfig.INITIAL_TOOLBAR_TIMEOUT;
        }
        if (typeof interfaceConfig.TOOLBAR_ALWAYS_VISIBLE !== 'undefined') {
            alwaysVisible = interfaceConfig.TOOLBAR_ALWAYS_VISIBLE;
        }
    }

    // When the toolbar is always visible, it must initially be visible too.
    if (alwaysVisible === true) {
        visible = true;
    }

    return {
        /**
         * The indicator which determines whether the Toolbox should always be
         * visible. When false, the toolbar will fade out after timeoutMS.
         *
         * @type {boolean}
         */
        alwaysVisible,

        isShareMenu: false,

        /**
         * The indicator which determines whether the labels on the toolbar buttons are visible.
         *
         * @type {boolean}
         */
        labelsVisible: true,

        /**
         * The indicator which determines whether the Toolbox is enabled.
         *
         * @type {boolean}
         */
        enabled: true,

        /**
         * The indicator which determines whether a Toolbar in the Toolbox is
         * hovered.
         *
         * @type {boolean}
         */
        hovered: false,

        /**
         * The indicator which determines whether the overflow menu(s) are to be displayed as drawers.
         *
         * @type {boolean}
         */
        overflowDrawer: false,

        /**
         * The indicator which determines whether the OverflowMenu is visible.
         *
         * @type {boolean}
         */
        overflowMenuVisible: false,

        /**
         * A number, non-zero value which identifies the timer created by a call
         * to setTimeout() with timeoutMS.
         *
         * @type {number|null}
         */
        timeoutID: null,

        /**
         * The delay in milliseconds before timeoutID executes (after its
         * initialization).
         *
         * @type {number}
         */
        timeoutMS,

        /** .........
         * This functionality is for zooming the state of the video
         *
         * @type {Number}
         */
        zoomin: 0,

        /** .........
         * This functionality is for zooming out the state of the video
         *
         * @type {Number}
         */
        zoomout: 0,

        /**
         * This functionality is for visibility of sharing screenss for the conference.
         *
         * @type {Number}
         */
        visibility: false,

        iframeVisible: false,
        openWhiteBoard: false,
        actionToggleWhiteBoard: false,

        /**
         * The indicator which determines whether the Toolbox is visible.
         *
         * @type {boolean}
         */
        visible,

        /**
         * The indicator which determines whether the Reactions are visible or not.
         *
         * @type {boolean}
         */
        showReactions: false,

        /**
         * The indicator which determines whether the Car Mode Modal is On or Off.
         *
         * @type {boolean}
         */
        isCarModeModalOpen: false,

        /**
         * The indicator which determines whether the Navigation Overflow Menu is Open or Close.
         *
         * @type {boolean}
         */
        isNavigationBarOverflowMenuOpen: false,

        isHangupMenuOpen: false,

        isOverflowMenuVisible: false,
        floatToolboxHidden: true
    };
}

ReducerRegistry.register(
    'features/toolbox',
    (state: Object = _getInitialState(), action: Object) => {
        switch (action.type) {
        case CLEAR_TOOLBOX_TIMEOUT:
            return {
                ...state,
                timeoutID: undefined
            };
        case FLOAT_TOOLBOX_HIDDEN:
            return {
                ...state,
                floatToolboxHidden: action.floatToolboxHidden
            };
        case HANGUP_MENU:
            return {
                ...state,
                isHangupMenuOpen: action.value
            };

        case FULL_SCREEN_CHANGED:
        case SET_FULL_SCREEN:
            return {
                ...state,
                fullScreen: action.fullScreen
            };

        case SET_OVERFLOW_DRAWER:
            return {
                ...state,
                overflowDrawer: action.displayAsDrawer
            };

        case SET_OVERFLOW_MENU_VISIBLE:
            return {
                ...state,
                overflowMenuVisible: action.visible
            };

        case SET_TOOLBAR_HOVERED:

            return {
                ...state,
                hovered: action.hovered
            };

        case SET_TOOLBOX_ALWAYS_VISIBLE:
            return {
                ...state,
                alwaysVisible: action.alwaysVisible,
                visible: action.alwaysVisible === true ? true : state.visible
            };

        case SET_TOOLBOX_ENABLED:
            return {
                ...state,
                enabled: action.enabled
            };

        case SET_TOOLBOX_TIMEOUT:
            return {
                ...state,
                timeoutID: action.timeoutID,
                timeoutMS: action.timeoutMS
            };

        case SET_TOOLBOX_TIMEOUT_MS:
            return {
                ...state,
                timeoutMS: action.timeoutMS
            };

        case SET_TOOLBOX_VISIBLE:
            return set(state, 'visible', state.alwaysVisible || action.visible);

        case SET_LABELS_VISIBLE:
            return {
                ...state,
                labelsVisible: action.visible
            };

        case TOGGLE_TOOLBOX_VISIBLE:
            return set(state, 'visible', state.alwaysVisible || !state.visible);
        case TOGGLE_TOOLBOX_ZOOMIN:
            return {
                ...state,
                zoomin: state.zoomin + 1
            };

        case TOGGLE_TOOLBOX_ZOOMOUT:
            return {
                ...state,
                zoomout: state.zoomout + 1
            };

        case SET_SHARE_MENU_VISIBLE:
            return {
                ...state,
                visibility: action.visible
            };
        case SET_WHITEBOARD_INSTANCE:
            return {
                ...state,
                iframeVisible: action.open
            };
        case TOGGLE_REACTIONS_BUTTON:
            return {
                ...state,
                showReactions: action.value
            };

        case OPEN_WHITE_BOARD:
            return {
                ...state,
                openWhiteBoard: action.open
            };
        case TOGGLE_OVERFLOW_MENU:
            return {
                ...state,
                isOverflowMenuVisible: action.overflowMenuVisible
            };

        case ACTION_TOGGLE_WHITE_BOARD:
            return {
                ...state,
                actionToggleWhiteBoard: action.bool
            };

        case OPEN_CARMODE_MODAL:
            return {
                ...state,
                isCarModeModalOpen: true
            };
        case CLOSE_CARMODE_MODAL:
            return {
                ...state,
                isCarModeModalOpen: false
            };
        case OPEN_NAVIGATION_BAR_OVERFLOW_MENU:
            return {
                ...state,
                isNavigationBarOverflowMenuOpen: action.isNavigationBarOverflowMenuOpen
            };
        case CLOSE_NAVIGATION_BAR_OVERFLOW_MENU:
            return {
                ...state,
                isNavigationBarOverflowMenuOpen: action.isNavigationBarOverflowMenuOpen
            };
        }


        return state;
    });
